"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _fishermanLogo = _interopRequireDefault(require("../data/fisherman-logo.svg"));

var _default = function _default() {
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
    src: _fishermanLogo["default"],
    width: 200,
    className: "checkout-fisherman-logo",
    as: 'a',
    href: 'https://gofisherman.com/',
    target: '_blank'
  });
};

exports["default"] = _default;